import { BooleanSwitch } from "./boolean-switch";
import { RadioSelect } from "./radio-select";
import { DropdownSelect } from "./dropdown-select";
import { useSettings } from "../settings-context";
import { TempSettingsType } from "../types";

type ChatSettingsProps = {
  tempSettings: TempSettingsType;
  handleChange: (key: string, value: string | boolean) => void;
};

export const ChatSettings = ({
  tempSettings,
  handleChange,
}: ChatSettingsProps) => {
  const { chatSettings } = useSettings();
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {Object.entries(chatSettings).map(([key, setting]) => {
        switch (setting.display_type) {
          case "Switch":
            return (
              <BooleanSwitch
                key={key}
                title={setting.name}
                value={!!tempSettings[key]}
                onChange={() => handleChange(key, !tempSettings[key])}
              />
            );
          case "Radio":
            return (
              <RadioSelect
                key={key}
                title={setting.name}
                value={tempSettings[key] ? String(tempSettings[key]) : ""}
                onChange={(e, val) => handleChange(key, val)}
                options={setting.available_options?.map(String) || []}
              />
            );
          case "Dropdown":
            return (
              <DropdownSelect
                key={key}
                title={setting.name}
                value={tempSettings[key] ? String(tempSettings[key]) : ""}
                onChange={(e) => handleChange(key, e.target.value as string)}
                options={setting.available_options?.map(String) || []}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
